import type { Dispatch, AnyAction } from 'redux';

import * as CreateOrganizationCredentialsAPI from 'ab-api/web/organizationCredential/create';
import * as DeleteOrganizationCredentialsAPI from 'ab-api/web/organizationCredential/delete';
import * as FindOrganizationCredentialsAPI from 'ab-api/web/organizationCredential/findAllForTable';
import * as UpdateOrganizationCredentialsAPI from 'ab-api/web/organizationCredential/update';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function findOrganizationCredentialsTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<FindOrganizationCredentialsAPI.W_OrganizationCredential_FindOrganizationCredentials_VM>(
				FindOrganizationCredentialsAPI.URL(data)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteOrganizationCredentials(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(
				DeleteOrganizationCredentialsAPI.URL(id)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createOrganizationCredential(request: CreateOrganizationCredentialsAPI.W_OrganizationCredential_Create_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post(
				CreateOrganizationCredentialsAPI.URL(),
				request
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function updateOrganizationCredential(id: number, request: UpdateOrganizationCredentialsAPI.W_OrganizationCredential_Update_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put(
				UpdateOrganizationCredentialsAPI.URL(id),
				request
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
